<template>
  <v-card
    :loading="loading"
    :disabled="loading"
  >
    <v-card-title class="align-start">
      <span>RECEBIMENTOS</span>
      <v-spacer></v-spacer>

      <v-btn
        icon
        small
        class="mt-n2 me-n3"
      >
        <v-icon size="22">
          {{ icons.mdiDotsVertical }}
        </v-icon>
      </v-btn>
    </v-card-title>

    <v-card-text>
      <v-row no-gutters>
        <v-col>
          Gráfico quantitativo de recebimentos
        </v-col>
      </v-row>
      <v-row>
        <v-col
          cols="12"
          sm="6"
        >
          <vue-apex-charts
            id="chart-sales-overview"
            :options="chartOptions"
            :series="chartData"
            class="h-full d-flex align-center"
          ></vue-apex-charts>
        </v-col>

        <v-col
          cols="12"
          sm="6"
          class="d-flex flex-column justify-center"
        >
          <div class="d-flex align-center">
            <v-avatar
              class="v-avatar-light-bg primary--text"
              rounded
              size="40"
            >
              <v-icon
                size="30"
                color="primary"
              >
                {{ icons.mdiCurrencyUsd }}
              </v-icon>
            </v-avatar>
            <div class="ms-4 d-flex flex-column">
              <p class="text--primary mb-0 text-base">
                Total
              </p>
              <span class="text--primary font-weight-semibold text-xl">R$ {{ formatMoney(totalReceive||0) }}</span>
            </div>
          </div>

          <v-divider class="my-6"></v-divider>

          <table class="sales-overview-stats-table">
            <tr>
              <td>
                <div class="mb-0">
                  <div class="stats-dot success d-inline-block rounded-circle me-2"></div>
                  <span>Pix</span>
                </div>
                <span class="text-base text--primary font-weight-semibold ms-4">R$ {{ formatMoney(methods.pix||0) }}</span>
              </td>
              <td>
                <div class="mb-0">
                  <div class="stats-dot success d-inline-block rounded-circle me-2"></div>
                  <span>Dinheiro</span>
                </div>
                <span class="text-base text--primary font-weight-semibold ms-4">R$ {{ formatMoney(methods.money||0) }}</span>
              </td>
            </tr>
            <tr>
              <td>
                <div class="mb-0">
                  <div class="stats-dot success d-inline-block rounded-circle me-2"></div>
                  <span>Faturado</span>
                </div>
                <span class="text-base text--primary font-weight-semibold ms-4">R$ {{ formatMoney(methods.invoice||0) }}</span>
              </td>
              <td>
                <div class="mb-0">
                  <div class="stats-dot secondary d-inline-block rounded-circle me-2"></div>
                  <span>C. Crédito</span>
                </div>
                <span class="text-base text--primary font-weight-semibold ms-4">R$ {{ formatMoney(methods.credit_card||0) }}</span>
              </td>
            </tr>

            <tr>
              <td>
                <div class="mb-0">
                  <div class="stats-dot secondary d-inline-block rounded-circle me-2"></div>
                  <span>C. Débito</span>
                </div>
                <span class="text-base text--primary font-weight-semibold ms-4">R$ {{ formatMoney(methods.debit_card||0) }}</span>
              </td>
              <td>
                <div class="mb-0">
                  <div class="stats-dot secondary d-inline-block rounded-circle me-2"></div>
                  <span>Outros</span>
                </div>
                <span class="text-base text--primary font-weight-semibold ms-4">R$ {{ formatMoney(methods.other||0) }}</span>
              </td>
            </tr>
          </table>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import {
  mdiDotsVertical,
  mdiCurrencyUsd,
} from '@mdi/js'
import {
  getVuetify,
  addAlpha,
} from '@core/utils'
import {
  mapActions,
} from 'vuex'

export default {
  components: {
    VueApexCharts: () => import('vue-apexcharts'),
  },
  data: () => ({
    loading: false,
    totalReceive: 0,
    values: [],
    labels: [],
    methods: {},
    icons: {
      mdiDotsVertical,
      mdiCurrencyUsd,
    },
  }),
  computed: {
    chartData() {
      return this.values
    },
    formatLabels() {
      const values = this.labels.map(item => {
        switch (item) {
          case 'money':
            return 'Dinheiro'
          case 'other':
            return 'Outros'
          case 'pix':
            return 'Pix'
          case 'credit_card':
            return 'C. Crédito'
          case 'debit_card':
            return 'C. Débito'
          case 'invoice':
            return 'Faturado'
        }
      })

      return values
    },
    chartOptions() {
      const $vuetify = getVuetify()

      return {
        labels: this.formatLabels,
        colors: [
          $vuetify.theme.currentTheme.success,
          addAlpha($vuetify.theme.currentTheme.success, 0.7),
          addAlpha($vuetify.theme.currentTheme.success, 0.5),
          addAlpha($vuetify.theme.currentTheme.secondary, 1.0),
          addAlpha($vuetify.theme.currentTheme.secondary, 0.7),
          addAlpha($vuetify.theme.currentTheme.secondary, 0.5),

        ],
        chart: {
          type: 'donut',
          sparkline: {
            enabled: true,
          },
        },
        plotOptions: {
          pie: {
            donut: {
              size: '70%',
              labels: {
                show: true,
                name: {
                  fontSize: '14px',
                  offsetY: 25,
                },
                value: {
                  fontSize: '2.125rem',
                  fontWeight: 600,

                  offsetY: -15,
                  formatter(value) {
                    value = parseFloat(value)

                    // formata o valor
                    value = value.toLocaleString('pt-br', {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    })

                    return `R$ ${value}`
                  },
                },
                total: {
                  show: true,
                  label: 'Recebimentos',
                  color: 'rgba(94, 86, 105, 0.68)',
                  formatter(value) {
                    // somatorio todos os valores
                    let total = value.globals.seriesTotals.reduce((total, num) => total + num)

                    // formata o valor
                    total = total.toLocaleString('pt-br', {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    })

                    return `R$ ${total}`
                  },
                },
              },
            },
          },
        },
      }
    },
  },
  created() {
    this.loading = true
    this.getReceive().then(response => {
      this.totalReceive = response.data.total,
      this.values = response.data.values
      this.labels = response.data.labels
      this.methods = response.data.data
    }).finally(() => {
      this.loading = false
    })
  },
  methods: {
    ...mapActions('dashboard', ['getReceive']),

    formatMoney(value) {
      if (value != null) {
        value = parseFloat(value)

        return value.toLocaleString('pt-br', {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        })
      }
    },

  },

}
</script>

<style lang="scss">
#chart-sales-overview {
    .apexcharts-canvas {
        .apexcharts-text {
            &.apexcharts-datalabel-value {
                font-weight: 600;
            }

            &.apexcharts-datalabel-label {
                font-size: 1rem;
            }
        }
    }
}

.sales-overview-stats-table {
    width: 100%;

    td {
        padding-bottom: 1rem;
    }

    .stats-dot {
        padding: 0.33rem;
    }

    // Set opacity of dots
    tr {
        &:nth-of-type(1) {
            td:nth-of-type(2) {
                .stats-dot {
                    opacity: 0.7;
                }
            }
        }

        &:nth-of-type(2) {
            td:nth-of-type(1) {
                .stats-dot {
                    opacity: 0.5;
                }
            }

            td:nth-of-type(2) {
                .stats-dot {
                    opacity: 0.15;
                }
            }
        }
    }
}
</style>
